<template>
  <div class="demo-page" data-test="try-teamio">
    <b-container>
      <Widget class="mx-auto demo-widget">
        <h5 class="demo-logo">
          <i class="fa fa-circle text-warning" />
          <img src="../../assets/teamio-logo.png" alt="Teamio" width="100" />
          <i class="fa fa-circle text-warning" />
        </h5>

        <div v-if="ended" class="demo-body" data-test="try-ended">
          <h4>Your demo has ended</h4>
          <p class="text-muted">
            Thanks for trying Teamio. Want to see how it would work for your practice? Book a short call and we'll
            walk you through it.
          </p>
        </div>
        <div v-else class="demo-body" data-test="try-intro">
          <h4>Try Teamio</h4>
          <p class="text-muted">
            Explore Teamio in a demo practice that's already set up with sample patients and messages. Book a short
            call and we'll send you a link to your own demo.
          </p>
          <p class="text-muted small">Already have a demo link? Open it from the email we sent you.</p>
        </div>

        <div class="demo-actions">
          <b-button variant="primary" :href="bookACallUrl" target="_blank" rel="noopener noreferrer" data-test="try-book-call">Book a call</b-button>
        </div>
        <p class="demo-signin small">
          Already a Teamio customer? <router-link to="/login">Sign in</router-link>
        </p>
      </Widget>
    </b-container>
    <footer class="footer">
      {{ year }} &copy; Teamio.app
    </footer>
  </div>
</template>

<script>
// Demo site (Try Teamio) — the public page a demo session ends on (logout → /try), and where the login page's
// "Try the live demo" link points (Task 6.7). Stage 1 has no self-serve sign-up: a demo starts from an operator's link.
import Widget from '@/components/Widget/Widget';
import { BOOK_A_CALL_URL } from '@/utils/demo/demoSession';
import { takeDemoEnded, safeSessionStorage } from '@/utils/demo/demoLanding';

export default {
  name: 'TryTeamio',
  components: { Widget },

  data() {
    return {
      ended: false,
      bookACallUrl: BOOK_A_CALL_URL,
      year: new Date().getFullYear(),
    };
  },

  created() {
    this.ended = takeDemoEnded(safeSessionStorage());
  },
};
</script>

<style src="./Demo.scss" lang="scss" scoped />
